import PromoFilter from './PromoFilter';

export default PromoFilter;
